import { ViewDensity } from "@common/types/views/views";
import { DENSITY_ROW_HEIGHT } from "@constants";

// Keep in sync with `$header-height` in ViewTable.module.scss.
export const HEADER_ROW_PX = 31;
const FOOTER_OVERHEAD_PX = 100 - HEADER_ROW_PX;

/**
 * Estimate how many rows fill the viewport on initial paint.
 * Used by the virtualizer as its `overscan` baseline so enough rows are
 * pre-rendered above and below the visible area.
 */
export function calculateInitialVisibleRows(
    fixedTopOffsetPx?: number,
    density: ViewDensity = ViewDensity.SM,
    headerDepth = 1,
): number {
    const viewportHeight = window?.innerHeight ?? 0;
    const topOffsetPx = fixedTopOffsetPx ?? 0;
    const overhead =
        topOffsetPx + FOOTER_OVERHEAD_PX + headerDepth * HEADER_ROW_PX;
    const rowHeight = DENSITY_ROW_HEIGHT[density];
    return Math.max(10, Math.ceil((viewportHeight - overhead) / rowHeight));
}
